import { Package, AlertTriangle } from "lucide-react";

interface MaterialOrderingGuideProps {
  squares: number;
  ridgeFt: number;
  eaveFt: number;
  rakeFt: number;
  valleyFt: number;
  wastePercent: number;
}

export function MaterialOrderingGuide({ squares, ridgeFt, eaveFt, rakeFt, valleyFt, wastePercent }: MaterialOrderingGuideProps) {
  const items = [
    { name: "Shingle Bundles", qty: Math.ceil(squares * 3), unit: "(3 = 1 SQ)" },
    { name: "Underlayment Rolls", qty: Math.ceil(squares / 4), unit: "(4 SQ/roll)" },
    { name: "Drip Edge Pieces", qty: Math.ceil((eaveFt + rakeFt) / 10), unit: "(10'/piece)" },
    { name: "Starter Strip Rolls", qty: Math.ceil(eaveFt / 100), unit: "(100'/roll)" },
    { name: "Ridge Cap Bundles", qty: Math.ceil(ridgeFt / 25), unit: "(25'/bundle)" },
    { name: "Ice & Water Rolls", qty: Math.ceil((eaveFt + valleyFt) / 65 / 2), unit: "(2 SQ/roll)" },
    { name: "Roofing Nails", qty: Math.ceil(squares * 3), unit: "lbs" },
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold flex items-center gap-2">
        <Package className="w-4 h-4 text-primary" /> Material Ordering Guide
      </h3>
      <div className="rounded-xl border border-border p-3 space-y-2 sm:p-4">
        <div className="grid grid-cols-1 gap-y-2 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-3 lg:grid-cols-4">
          {items.map((it) => (
            <div key={it.name} className="flex items-start justify-between gap-3 rounded-lg border border-border/60 bg-background/40 px-3 py-2 text-sm sm:rounded-none sm:border-0 sm:bg-transparent sm:px-0 sm:py-0">
              <div className="min-w-0">
                <div className="font-medium break-words">{it.name}</div>
                <div className="text-xs text-muted-foreground">{it.unit}</div>
              </div>
              <div className="shrink-0 text-2xl font-bold text-foreground tabular-nums">{it.qty}</div>
            </div>
          ))}
        </div>
        <div className="flex items-start gap-2 pt-3 border-t border-border text-xs text-muted-foreground">
          <AlertTriangle className="w-3.5 h-3.5 text-amber-500" />
          <span className="break-words">Quantities include {wastePercent}% waste factor. Verify before ordering.</span>
        </div>
      </div>
    </div>
  );
}
